import React, { memo } from 'react';
import { DialogBody, DialogFooter, ButtonGroup, Button, Message, Interpolate } from '@wg/wows-react-uikit';

import { t } from '~/helpers/localization';

import styles from './ClanNameEditDialog.scss';

interface PreModerationNoticeProps {
  onClose: () => void;
}

const PreModerationNotice: React.FC<PreModerationNoticeProps> = ({ onClose }) => (
  <>
    <DialogBody>
      <div className={styles.preModerationHelp}>
        <Message style={'inline'} type="error">
          <Interpolate
            useDangerouslySetInnerHTML
            str={t(
              'Вы не можете изменить %(pre_moderation_property_name)s, пока профиль вашего клана находится на премодерации.',
            )}
            parentTag={'p'}
            pre_moderation_property_name={t('название и тег клана:pre_moderation_property_name')}
          />
        </Message>
      </div>
    </DialogBody>
    <DialogFooter>
      <ButtonGroup>
        <Button isJustified isFlat onClick={onClose}>
          {t('Закрыть')}
        </Button>
      </ButtonGroup>
    </DialogFooter>
  </>
);

export default memo(PreModerationNotice);
